import React from 'react';
import RoutePropsSwitch from './RoutePropsSwitch';
import { unauthorizedRoutes, isUnathorizedRoute } from './routes/unauthorizedRoutes';
import Layout from 'features/shared/layout/Layout';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import ISidebarService from 'features/shared/layout/sidebar/services/ISidebarService';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import IAppState from 'infrastructure/store/IAppState';
import { UserState } from 'redux-oidc';
import CustomerSimplifiedDTO from 'features/customer/dtos/CustomerSimplifiedDTO';
import CustomerSelect from "features/customer/CustomerSelect";
import moduleRoutes from "features/shared/layout/sidebar/components/ModuleRoutes";
import loginRoutes from "infrastructure/oidc/LoginRoutes";
import LoginPage from 'infrastructure/oidc/LoginPage';
import otherRoutes from './routes/otherRoutes';
import AdminUserState from 'infrastructure/store/adminUser/AdminUserState';
import { loadModule } from '../helpers/modules';
import Administration from 'features/admin/Administration';
import { isAdminUser } from 'infrastructure/oidc/oidcHelper';

const menuJson = loadModule<any>("menu/sidebarmenu.json");

interface Props {
  
}

const ApplicationRouter = (props: Props) => {
  //#region DI
  const sidebarService = useInjection<ISidebarService>(IocTypes.SidebarService);
  //#endregion DI

  //#region ROUTER
  const history = useHistory();
  //#endregion ROUTER

  //#region STORE
  const userState = useSelector<IAppState, UserState>((store) => store.oidc);
  const customer = useSelector<IAppState, CustomerSimplifiedDTO>((state) => state.customer.customer);
  const adminUser = useSelector<IAppState, AdminUserState>((state) => state.adminUser);
  //#endregion STORE

  //#region HELPERS
  const isEmptyCustomer = (): boolean => {
    return customer.customerId === undefined || customer.customerId === "";
  }
  //#endregion HELPERS

  //#region RENDER
  if (isUnathorizedRoute(history.location.pathname)) {
    // stránky, na které může vstoupit nepřihlášený uživatel
    return <RoutePropsSwitch routes={unauthorizedRoutes} />;
  } else if (!userState.user) {
    // nepřihlášený uživatel
    // zobrazí se pouze LoginPage, kde dojde k přesměrování na IS4
    return (
      <RoutePropsSwitch
        routes={[
          { exact: true, path: "/", component: LoginPage },
          ...loginRoutes,
        ]}
      />
    );
  } else if (isAdminUser(userState.user) && !adminUser.isSelectedUser) {
    // přihlášený admin uživatel, bez vybraného uživatele
    // zobrazí se administrace
    return (
      <RoutePropsSwitch
        routes={[
          ...loginRoutes,
          { path: "/", component: Administration },
        ]}
      />
    );
  } else if (isEmptyCustomer()) {
    // přihlášený uživatel, bez vybraného zákazníka
    // zobrazí se pouze stránka pro výběr zákazníka
    return (
      <RoutePropsSwitch
        routes={[
          { exact: true, path: "/", component: CustomerSelect },
          ...loginRoutes,
        ]}
        redirectAllToPath="/"
      />
    );
  } else {
    // přihlášený uživatel s vybraným zákazníkem
    // zobrazí se klasický layout s možnostmi přepínání mezi moduly
    return (
      <Layout sidebarItems={sidebarService.getMenuItemsFromJson(menuJson)}>
        <RoutePropsSwitch
          routes={[
            ...loginRoutes,
            ...moduleRoutes(
              sidebarService.getMenuItemsFromJson(menuJson),
              sidebarService
            ),
            ...otherRoutes,
          ]}
          redirectAllToPath="/"
        />
      </Layout>
    );
  }
  //#endregion RENDER
}

export default ApplicationRouter;
